import { Filter } from "./records";

// ObjectRelation represents the relation between two objects
// An relation is uniquely defined by a source object key (DocFrom), a destination object key and a name.
// Thus, for the same pair of source and destination object, there can be several relation defined with different name.
// Name cannot be empty.
// In addition to the name, source and destination cardinality are defined with a default value of -1, representing a cardinality of n.
interface ObjectRelation {
	_key: string;
	_from: string;
	_to: string;
	name: string;
	srcCard: number;
	destCard: number;
	order: number;
	srcFilter?: Filter | null;
	destFilter?: Filter | null;
}

interface ObjectRelationRequest {
	relationKey?: string;
	srcObjectKey?: string;
	destObjectKey?: string;
	name?: string;
}

enum RelationCardinality {
	ManyToOne = "ManyToOne",
	OneToMany = "OneToMany",
	ManyToMany = "ManyToMany",
	OneToOne = "OneToOne",
}

export const DefaultRelationCardinality = RelationCardinality.ManyToOne;

export function getSrcCard(cardinality: RelationCardinality) {
	let card = cardinality;
	if (!cardinality) {
		card = DefaultRelationCardinality;
	}
	return (card === RelationCardinality.ManyToOne || card === RelationCardinality.ManyToMany) ? -1 : 1;
}

export function getDestCard(cardinality: RelationCardinality) {
	let card = cardinality;
	if (!cardinality) {
		card = DefaultRelationCardinality;
	}
	return (card === RelationCardinality.OneToMany || card === RelationCardinality.ManyToMany) ? -1 : 1;
}

export function getRelationCardinality(srcCard: number, destCard: number) {
	return srcCard === -1 && destCard === 1 ? RelationCardinality.ManyToOne 
	: srcCard === 1 && destCard === -1 ? RelationCardinality.OneToMany 
	: srcCard === 1 && destCard === 1 ? RelationCardinality.OneToOne 
	: RelationCardinality.ManyToMany;
}

export { RelationCardinality };
export type { ObjectRelation, ObjectRelationRequest };
